import React, { useState } from 'react';
import { Check, XCircle } from 'lucide-react';
import { ActionMenuItem, ActionsDropdownMenu } from '../deep-links/ActionsDropdownMenu';

type MembershipTransferActionsMenuProps = {
  disabled?: boolean;
  onApprove: () => void;
  onReject: () => void;
};

const MembershipTransferActionsMenu: React.FC<MembershipTransferActionsMenuProps> = ({
  disabled = false,
  onApprove,
  onReject,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <ActionsDropdownMenu
      open={open}
      onToggle={() => {
        if (disabled) return;
        setOpen((value) => !value);
      }}
      onClose={() => setOpen(false)}
    >
      <ActionMenuItem
        icon={<Check className="h-4 w-4 text-emerald-600 dark:text-emerald-400" />}
        label="Approve transfer"
        disabled={disabled}
        onClick={() => {
          setOpen(false);
          onApprove();
        }}
      />
      <ActionMenuItem
        icon={<XCircle className="h-4 w-4 text-red-500" />}
        label="Reject transfer"
        tone="danger"
        disabled={disabled}
        onClick={() => {
          setOpen(false);
          onReject();
        }}
      />
    </ActionsDropdownMenu>
  );
};

export default MembershipTransferActionsMenu;
